var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-video",style:(_vm.styles),on:{"click":function($event){return _vm.$emit('click')}}},[_c('em',{staticClass:"c-video-play"})])
}
var staticRenderFns = []

export { render, staticRenderFns }